import { render, staticRenderFns } from "./ExameResultado.vue?vue&type=template&id=b3021c2a&scoped=true&"
import script from "./ExameResultado.vue?vue&type=script&lang=js&"
export * from "./ExameResultado.vue?vue&type=script&lang=js&"
import style0 from "./ExameResultado.vue?vue&type=style&index=0&id=b3021c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3021c2a",
  null
  
)

export default component.exports